import { AnimateOnScroll } from 'animate-on-scroll-framer'
import React from 'react'

export default function REVENUESHARING() {
  return (
    <div
      className='md:mt-44 mt-20 '
      id='revenuesharing'
    >
      <div className='grid md:grid-cols-2 grid-cols-1 md:gap-5 gap-10'>
        <AnimateOnScroll animation='flipIn'>
          <div className='md:justify-start justify-center'>
            <img
              src='/images/div.framer-muak3.png'
              alt='about'
              className=' md:h-[400px]  h-[270px] object-contain'
            />
          </div>
        </AnimateOnScroll>
        <div className='space-y-7 relative'>
          <AnimateOnScroll animation='flipIn'>
            <div className='bg-black border border-[#FFFFFF1F] text-[#FF8A3D] text-center rounded-full w-48 py-2 px-5'>
              <h5>REVENUE SHARING</h5>
            </div>
          </AnimateOnScroll>
          <AnimateOnScroll animation='flipIn'>
            <h1 className='md:text-5xl text-3xl font-semibold'>
              TOOLS AI's Revenue Sharing Plan
            </h1>
          </AnimateOnScroll>
          <AnimateOnScroll animation='flipIn'>
            <p className='font-light'>
              TOOLS AI's innovative approach includes revenue sharing with token
              holders and implementing a token gate system for accessing the
              TOOLS AI Bot. Token holders will enjoy exclusive access to the
              bot, with generated revenue distributed among them. Non-holders
              will have access to the bot through a fee-based system,
              incentivizing token ownership while ensuring fair access to all
              users.
            </p>
          </AnimateOnScroll>

          <button className='button1 px-8 py-3 rounded-full font-semibold text-lg '>
            <AnimateOnScroll animation='flipIn'>Get Started</AnimateOnScroll>
          </button>
        </div>
      </div>
    </div>
  )
}
